import {Directive, ElementRef, forwardRef, HostListener, Renderer2} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DecimalToCommaPipe} from '../pipes/decimal-to-comma.pipe';
import {CommaToDecimalPipe} from '../pipes/comma-to-decimal.pipe';

@Directive({
    selector: '[appTransformInput]',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TransformInputDirective),
        multi: true
    }]
})
export class TransformInputDirective implements ControlValueAccessor {


    constructor(private _renderer: Renderer2, private _elementRef: ElementRef) {
    }

    writeValue(value: string) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', new DecimalToCommaPipe().transform(value));
    }

    onChangeCallback = (_: any) => {
    };
    onTouchedCallback = (_: any) => {
    };

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    @HostListener('blur', ['$event']) onBlur($event) {
        this.onTouchedCallback($event);
    }


    @HostListener('input', ['$event.target.value']) input(value: any) {
        if (!value) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'value', null);
            this.onChangeCallback(null);
            return;
        }
        if (value) {
            const sepPosition = value.toString().indexOf(',');
            if (sepPosition > -1 && value.toString().substr(sepPosition + 1).length > 2) {
                value = value.substr(0, sepPosition + 3);
                this._renderer.setProperty(this._elementRef.nativeElement, 'value', value);
            }
            const res = new CommaToDecimalPipe().transform(value);
            if (value[0] === '0' && value[1] !== ',' && res > 0) {
                value = value.substr(1);
                this._renderer.setProperty(this._elementRef.nativeElement, 'value', value);
            }
            this.onChangeCallback(res);
        }
    }
}
